import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import LoanTableRecords from '../LoansTableRecords';

const AwaitingApprovalLoans = () => (
  <LoanTableRecords defaultUrl={AdminRouteName.awaitingApprovalLoansRoute} tabStatus="AWAITING_APPROVAL" toggleStorageId="awaiting-approval-credit-request-table-col" hasNameAndImage permissionName="can-view-awaiting-approval-credit-request" />
);
export default AwaitingApprovalLoans;
